import { MEGABYTES } from '@roko/ui/constants/common'

export const sleep = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const convertBytesToMegabytes = (bytes: number) => {
  return (bytes / (1024 * 1024)).toFixed(2) + MEGABYTES
}
